module.exports = new __parcel__URL__("Charlie_Display-Light.623ad327.woff").toString();